import { LoginFormData } from "../types/loginFormData";
import axiosInstance from "@/lib/axiosInterceptor";
import { Result } from "types/result";

interface Data {
    access_token: string;
    email: string;
}

export const loginFn = async (formData: LoginFormData): Promise<Result<Data>> => {
    try {
        const response = await axiosInstance.post<Data>(
            `${process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL}/auth/login`,
            formData,
        );
        return {
            data: response.data,
            error: null,
        };
    } catch (e: any) {
        return {
            data: null,
            error: {
                messageKey: e.response.data.response.messageKey,
                message: e.response.data.response.message || e.message,
                data: e.response.data.response.data,
            },
        };
    }
};
